import React, { useContext } from 'react';

import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import { MobileSizeContext } from '../../../helpers/MobileSizeContext';
import Strip from '../../common/Strip';
import TextHeader from '../../common/TextHeader';
import { Link } from '../../elements';
import Styles from './OneStopExecution.module.scss';

const OneStopExecution = () => {
  const { t } = useTranslation('clients');
  const { isMobileSmall } = useContext(MobileSizeContext);

  const {
    oneStopExecution: { title, description, cta, button },
  } = t('corporate-treasurers', {
    returnObjects: true,
  }) as any;

  return (
    <Strip variant="white" style={{ paddingBottom: 0 }}>
      <div className={Styles.wrapper}>
        <div className={Styles.column}>
          <TextHeader
            level={1}
            data={{
              title: <span style={{ maxWidth: 320, display: 'inline-block' }}>{title}</span>,
              description: [description],
            }}
            variant={isMobileSmall ? 'centered' : 'alignedLeft'}
          />

          <Link
            variant={isMobileSmall ? ['ctaMint', 'dark', 'centered'] : ['ctaMint', 'dark']}
            to={cta}
            style={{ marginTop: 28 }}
          >
            {button}
          </Link>
        </div>
        <div className={Styles.column}>
          <Image
            style={{ marginBottom: -37 }}
            src="/images/client/mainIllustration.webp"
            alt={title}
            width={515}
            height={415}
          />
        </div>
      </div>
    </Strip>
  );
};

export default OneStopExecution;
